/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateJoinRequestsRead.defs'
export { main as default } from './updateJoinRequestsRead.defs'
